import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  if (config.public.amplitudeAnalyticsId) {
    (window as any).amplitude?.init(config.public.amplitudeAnalyticsId, {
      fetchRemoteConfig: true,
      autocapture: true,
    });
  }
});
